import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

// Puts a secret on every WhatsApp webhook Green API sends, so nobody can fake
// a message from the admin's number to the bot.
const WebhookLock = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => axios.get(`${API}/whatsapp/webhook-lock`).then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const set = async (locked) => {
    if (!window.confirm(locked
      ? "Lock the WhatsApp webhook? The bot's WhatsApp restarts once (about a minute)."
      : "Unlock it? Anyone who finds the webhook address could send fake admin messages again.")) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/whatsapp/webhook-lock`, { locked });
      setD(r.data);
      toast.success(locked ? "Locked — confirms itself on the next WhatsApp message" : "Unlocked");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
    setBusy(false);
  };

  if (!d) return null;
  const status = !d.locked ? "Not locked" : d.confirmed_at ? "Locked and working" : "Locked — waiting for the first message";
  return (
    <div className={`card p-4 sm:p-6 space-y-3 ${d.locked ? "" : "border border-red-500/50"}`} data-testid="webhook-lock">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h2 className="text-lg font-bold text-white">WhatsApp webhook lock</h2>
        <span className={`text-xs px-2 py-1 rounded ${d.locked && d.confirmed_at ? "bg-[#00E054]/15 text-[#00E054]" : d.locked ? "bg-amber-500/20 text-amber-300" : "bg-red-500/20 text-red-300"}`}>{status}</span>
      </div>
      <p className="text-xs text-gray-500">
        Without the lock, anyone who finds the bot's webhook address can send it a fake message "from" your number,
        and the bot would follow it (reboot a machine, change a worker). Locking adds a secret that only Green API knows.
      </p>
      {d.locked && (
        <p className="text-[11px] text-gray-500">
          Fake messages blocked: {d.rejected || 0}{d.last_rejected_at ? ` · last ${new Date(d.last_rejected_at).toLocaleString()}` : ""}
        </p>
      )}
      <button onClick={() => set(!d.locked)} disabled={busy}
              className={`px-3 py-2 rounded-md text-sm font-bold disabled:opacity-50 ${d.locked ? "border border-[#27272A] text-gray-300" : "bg-[#00E054] text-black"}`}>
        {d.locked ? "Unlock" : "Lock the webhook"}
      </button>
    </div>
  );
};

export default WebhookLock;
